/* eslint-disable camelcase */
import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger from '@wix/bi-logger-marketing-integration';
import { getMandatoryBIFields } from '@wix/business-manager-api';

export default class BiLoggerStore {
  constructor({ config, pubSub, stores }) {
    this.pubSub = pubSub;
    this.stores = stores;
    this.logger = initSchemaLogger(webBiLogger)({});
    const mandatoryBIFields = getMandatoryBIFields();
    this.logger.util.updateDefaults({
      msid: config.metaSiteId,
      ...mandatoryBIFields,
    });
  }

  _updateData({ data = {}, integrationType, modalType }) {
    if (
      integrationType === 'mailChimp' &&
      modalType === 'mailchimp connections'
    ) {
      data.existingConnectionsNumber = this.stores.mailchimp.connectionsArray.length;
    }
    return data;
  }
  openApp() {
    this.logger.openApp({
      is_premium: this.stores.appConfig.isPremium,
      referral_info: this.stores.navigation.query.referralInfo || '',
    });
  }

  integrationsHomePageView() {
    this.logger.integrationsHomePageView({
      is_premium: this.stores.appConfig.isPremium,
    });
  }

  integrationClick({ type }) {
    this.logger.integrationClick({
      integration_name: type,
      is_premium: this.stores.appConfig.isPremium,
    });
  }

  integrationPageView({ type }) {
    this.logger.integrationPageView({
      integration_name: type,
      is_premium: this.stores.appConfig.isPremium,
    });
  }
  integrationPageMainActionButtonClick({ location, type }) {
    this.logger.integrationPageSetupButtonClick({
      integration_name: type,
      is_premium: this.stores.appConfig.isPremium,
      location,
    });
  }

  integrationModalView(biData) {
    this.logger.integrationModalView({
      integration_name: biData.integrationType,
      modal_type: biData.modalType,
      is_premium: this.stores.appConfig.isPremium,
      data: JSON.stringify(this._updateData(biData)),
    });
  }

  integrationModalClosed(biData) {
    this.logger.integrationModalClosed({
      integration_name: biData.integrationType,
      modal_type: biData.modalType,
      is_premium: this.stores.appConfig.isPremium,
      data: JSON.stringify(this._updateData(biData)),
    });
  }

  integrationModalCtaClick(biData) {
    this.logger.integrationModalCtaClick({
      cta_type: biData.ctaType,
      integration_name: biData.integrationType,
      is_premium: this.stores.appConfig.isPremium,
      modal_type: biData.modalType,
    });
  }

  integrationModalFootNoteClick(biData) {
    this.logger.integrationModalFootNoteClick({
      integration_name: biData.integrationType,
      is_premium: this.stores.appConfig.isPremium,
      modal_type: biData.modalType,
    });
  }

  integrationModalCloseViaCloseBar(biData) {
    this.logger.integrationModalClose({
      integration_name: biData.integrationType,
      is_premium: this.stores.appConfig.isPremium,
      modal_type: biData.modalType,
    });
  }

  integrationFbCopyLinkClick() {
    this.logger.integrationFbCopyLinkClick({
      is_premium: this.stores.appConfig.isPremium,
    });
  }

  mcIntegrationWixLabelSelect(biData) {
    this.logger.mcIntegrationWixLabelSelect({
      is_premium: this.stores.appConfig.isPremium,
      wix_label_name: biData.selectedId,
    });
  }

  mcIntegrationMcListSelect(biData) {
    this.logger.mcIntegrationMcListSelect({
      is_premium: this.stores.appConfig.isPremium,
      mc_list_id: biData.selectedId,
    });
  }

  mailchimpConnectClick(biData) {
    this.logger.mailchimpConnectClick({
      is_premium: this.stores.appConfig.isPremium,
      mc_list_id: biData.mailChimpListId,
      wix_label_name: biData.wixLabelId,
    });
  }

  mailchimpConnectSuccess(biData) {
    this.logger.mailchimpConnectSuccess({
      is_premium: this.stores.appConfig.isPremium,
      mc_list_id: biData.mailChimpListId,
      wix_label_name: biData.wixLabelId,
    });
  }

  mailchimpCreateAnother() {
    this.logger.mailchimpCreateAnother({
      is_premium: this.stores.appConfig.isPremium,
    });
  }

  mailchimpDeleteConnection(biData) {
    const connection = this.stores.mailchimp.findConnectionByUID(
      biData.connectionUID,
    );
    this.logger.mailchimpDeleteConnection({
      is_premium: this.stores.appConfig.isPremium,
      mc_list_id: connection.toMailChimpId,
      wix_label_name: connection.fromWixLabelId,
    });
  }

  mcIntegrationModalTooltipView(biData) {
    this.logger.mcIntegrationModalTooltipView({
      is_premium: this.stores.appConfig.isPremium,
      tooltip_name: biData.tooltipName,
    });
  }

  mcIntegrationModalTooltipClose(biData) {
    this.logger.mcIntegrationModalTooltipClose({
      is_premium: this.stores.appConfig.isPremium,
      tooltip_name: biData.tooltipName,
    });
  }

  embeddedCodeSaveInitiate(biData) {
    this.logger.embeddedCodeSaveInitiate({
      integration_name: biData.integrationType,
      isPremium: this.stores.appConfig.isPremium,
    });
  }

  embeddedCodeSaveSuccess(biData) {
    this.logger.embeddedCodeSaveSuccess({
      integration_name: biData.integrationType,
      isPremium: this.stores.appConfig.isPremium,
    });
  }

  embeddedCodeSaveError(biData) {
    this.logger.embeddedCodeSaveError({
      integration_name: biData.integrationType,
      isPremium: this.stores.appConfig.isPremium,
      errorType: biData.errorType,
    });
  }

  integrationPageMenuClick(biData) {
    this.logger.integrationPageMenuClick({
      integration_name: biData.integrationType,
      isPremium: this.stores.appConfig.isPremium,
    });
  }

  integrationPageMenuOptionClick(biData) {
    this.logger.integrationPageMenuOptionClick({
      integration_name: biData.integrationType,
      isPremium: this.stores.appConfig.isPremium,
      options: biData.option,
    });
  }
}
